/* Restyles Shopify's <shop-follow-button> to match the black footer:
   black background, white border, white text.

   The component renders into an open shadow root with no ::part() hooks and no
   CSS custom properties, so the only way in is appending a <style> to that
   shadow root. */
(function () {
  const SELECTOR = 'shop-follow-button';
  const MARK = 'data-rm-follow-style';

  // The pill background is a separate absolutely-positioned div, and every
  // white part (icon strokes, wordmark fill, label) inherits currentColor from
  // .text-white — so one color override on it flips the whole content.
  const CSS = `
    button {
      border: 1px solid #fff !important;
    }
    [class*="bg-purple"] {
      background-color: #000 !important;
    }

    button:hover {
      border-color: #000 !important;
    }
    button:hover [class*="bg-purple"] {
      background-color: #fff !important;
    }
    button:hover [class*="text-white"] {
      color: #000 !important;
    }
  `;

  function paint(host) {
    const root = host.shadowRoot;
    if (!root || root.querySelector('style[' + MARK + ']')) return;
    const style = document.createElement('style');
    style.setAttribute(MARK, '');
    style.textContent = CSS;
    root.appendChild(style);
  }

  function watch(host) {
    paint(host);
    if (host.__rmFollowObserved) return;
    host.__rmFollowObserved = true;
    // The component re-renders its shadow tree (e.g. once the follow state
    // resolves), which drops our <style> — re-append it on every change.
    // paint() is a no-op while the style is still there, so this cannot loop.
    new MutationObserver(() => paint(host)).observe(host.shadowRoot, {
      childList: true,
      subtree: true,
    });
  }

  function boot() {
    const hosts = document.querySelectorAll(SELECTOR);
    if (hosts.length === 0) return false;
    let ready = true;
    hosts.forEach(host => {
      if (host.shadowRoot) watch(host);
      else ready = false;
    });
    return ready;
  }

  // The Shop script defines the element asynchronously, so the shadow root is
  // usually not there yet on first run.
  if (boot()) return;
  const startedAt = Date.now();
  const timer = setInterval(() => {
    if (boot() || Date.now() - startedAt > 15000) clearInterval(timer);
  }, 200);
})();
